import axios from '../../services/axios.service';
import { getEndpointBase } from '../../services/api.service';
import { ReportFetchParams } from './Report.type';

let request: any = null;

const transformParams = (params: ReportFetchParams) => ({
  ...params,
  groupBy: params.groupBy.toUpperCase(),
  subGroupBy: params.subGroupBy?.toUpperCase(),
  selectAll: params.selectAll ? '1' : undefined,
});

const reportService = {
  getReport: (params: ReportFetchParams) => {
    request && request.cancel();
    request = axios.CancelToken.source();
    return axios.get(getEndpointBase(`report`), {
      cancelToken: request.token,
      params: transformParams(params),
    });
  },
  getMultipleReport: (params: ReportFetchParams) => {
    request && request.cancel();
    request = axios.CancelToken.source();
    return axios.get(getEndpointBase(`report/multiple`), {
      cancelToken: request.token,
      params: transformParams(params),
    });
  },
};

export default reportService;
